import { render, staticRenderFns } from "./landdetail.vue?vue&type=template&id=6deb1dd2&scoped=true"
import script from "./landdetail.vue?vue&type=script&lang=js"
export * from "./landdetail.vue?vue&type=script&lang=js"
import style0 from "./landdetail.vue?vue&type=style&index=0&id=6deb1dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb1dd2",
  null
  
)

export default component.exports